import React from 'react'

function CourseOverview({ contentData }) {
  if (!contentData) {
    return <div>No content data available</div>
  }

  return (
    <div>
      <p className="text-xs font-medium text-font-secondary uppercase tracking-wide mb-2">Duration: {contentData.duration}</p>
      <h3 className="text-base font-semibold text-font-primary mb-2">{contentData.title}</h3>
      <div className="text-sm text-font-secondary leading-relaxed">
        <p>{contentData.description || 'No description.'}</p>
      </div>
    </div>
  )
}

export default CourseOverview